import { Link } from "react-router-dom";
import { getDailyVerse } from "../../../mocks/dailyVerses";
import { getDailyLesson } from "../../../mocks/dailyLessons";

export default function Devotionals() {
  const today = new Date();
  const verse = getDailyVerse(today);
  const lesson = getDailyLesson(today);

  const dateLabel = today.toLocaleDateString("en-US", {
    month: "long",
    day: "numeric",
    year: "numeric",
  });

  return (
    <section id="devotionals" className="bg-[#0a0a0a] py-24 px-4">
      <div className="text-center mb-14">
        <p className="text-[#ef4444] text-xs font-medium uppercase tracking-widest mb-2">{dateLabel}</p>
        <h2 className="text-3xl md:text-4xl font-bold text-white mb-3">Daily Devotionals</h2>
        <p className="text-[#555] text-sm md:text-base">
          Fresh from Scripture — new every morning
        </p>
      </div>

      <div className="max-w-5xl mx-auto grid grid-cols-1 lg:grid-cols-2 gap-4 mb-10">
        {/* Verse of the Day */}
        <div className="bg-[#111] border border-[#1e1e1e] rounded-xl p-6 flex flex-col justify-between">
          <div>
            <p className="text-[#ef4444] text-xs font-medium uppercase tracking-widest mb-4">
              Verse of the Day
            </p>
            <blockquote className="text-white text-base leading-relaxed font-light mb-4">
              &ldquo;{verse.text}&rdquo;
            </blockquote>
            <p className="text-[#555] text-sm">
              &mdash; {verse.reference} ({verse.translation})
            </p>
          </div>
          <Link
            to="/scripture"
            className="mt-6 inline-flex items-center gap-1.5 text-[#ef4444] text-sm hover:gap-2.5 transition-all cursor-pointer"
          >
            Read Full Chapter <i className="ri-arrow-right-line" />
          </Link>
        </div>

        {/* Daily Mini Lesson */}
        <div className="bg-[#111] border border-[#1e1e1e] rounded-xl p-6 flex flex-col">
          <div className="flex items-center gap-2 mb-3">
            <p className="text-[#ef4444] text-xs font-medium uppercase tracking-widest">
              Today&apos;s Lesson
            </p>
            <span className="text-[#2e2e2e]">&middot;</span>
            <span className="text-[#555] text-xs">{lesson.passage}</span>
          </div>
          <h3 className="text-white text-lg font-semibold mb-2">{lesson.title}</h3>
          <p className="text-[#666] text-sm leading-relaxed mb-4">{lesson.summary}</p>
          <ul className="space-y-2 mb-4">
            {lesson.points.slice(0, 2).map((pt) => (
              <li key={pt} className="flex items-start gap-2 text-xs text-[#666]">
                <i className="ri-checkbox-circle-line text-[#ef4444] mt-0.5 flex-shrink-0" />
                {pt}
              </li>
            ))}
          </ul>
          <div className="mt-auto pt-4 border-t border-[#1e1e1e]">
            <p className="text-[#444] text-xs italic">&ldquo;{lesson.reflection}&rdquo;</p>
          </div>
          <Link
            to="/devotionals"
            className="mt-4 inline-flex items-center gap-1.5 text-[#ef4444] text-sm hover:gap-2.5 transition-all cursor-pointer"
          >
            Read Full Lesson <i className="ri-arrow-right-line" />
          </Link>
        </div>
      </div>
    </section>
  );
}
